import heroSlide1 from '../assets/home/hero-slideshow/slide1.png';
import heroSlide2 from '../assets/home/hero-slideshow/slide2.png';
import heroSlide3 from '../assets/home/hero-slideshow/slide3.png';
import heroSlide4 from '../assets/home/hero-slideshow/slide4.png';
import heroSlide5 from '../assets/home/hero-slideshow/slide5.png';
import heroSlide6 from '../assets/home/hero-slideshow/slide6.png';

export const DEFAULT_HERO_SLIDES = [
  heroSlide1,
  heroSlide2,
  heroSlide3,
  heroSlide4,
  heroSlide5,
  heroSlide6,
];

export function resolveHeroSlides(getContent) {
  const stored = getContent('home.hero.slides', null);
  if (Array.isArray(stored) && stored.length) return stored;
  return DEFAULT_HERO_SLIDES;
}
